import React from "react";
import { useOutletContext } from "react-router-dom";
import { ClipboardCheck } from "lucide-react";
import InspectionReport, { CleaningPlanCard } from "./InspectionReport";
import ConformitySummary from "./ConformitySummary";
import TraceabilitySearch from "../../components/TraceabilitySearch";
import { RecallInspectionCard } from "../../components/RecallBanner";
import AcademyTitleBadge from "../../academy/AcademyTitleBadge";
import SafeGuardArchive from "../../components/SafeGuardArchive";
import DeviceRecords from "../../components/DeviceRecords";
import { canSeeArchive } from "../../lib/safeguardCache";
import { useAuth } from "../../context/AuthContext";

export default function Ispezione() {
  const { ctx, isLocked } = useOutletContext();
  const { user } = useAuth();
  // Addetti: niente archivio ispettivo; arrivano qui solo da «Dettagli» della barra offline.
  if (!canSeeArchive(user)) {
    return (
      <div className="space-y-6" data-testid="ispezione-page-addetto">
        <h1 className="font-heading text-3xl font-bold">Registrazioni su questo dispositivo</h1>
        <p className="text-sm text-slate-500 font-body">L'archivio per l'ispezione ASL/NAS lo consultano titolare e responsabili. Qui trovi le registrazioni fatte da questo telefono, anche senza connessione.</p>
        <DeviceRecords />
      </div>
    );
  }
  return (
    <div className="space-y-6" data-testid="ispezione-page">
      <div><p className="text-xs uppercase tracking-[0.18em] text-slate-400 font-body">Verifica ispettiva</p>
        <div className="flex flex-wrap items-center gap-2"><h1 className="font-heading text-3xl font-bold flex items-center gap-2"><ClipboardCheck className="w-7 h-7 text-navy" /> Ispezione ASL/NAS</h1><AcademyTitleBadge /></div>
        <p className="text-sm text-slate-500 font-body mt-1">Per il controllo ASL/NAS: l’archivio verificato dei report giornalieri e mensili, poi gli strumenti per le conformità del mese e i report su misura.</p></div>
      <SafeGuardArchive />
      <h2 className="pt-2 font-heading text-2xl font-semibold" data-testid="ispezione-tools-title">Altri strumenti per il controllo</h2>
      {!isLocked?.("materie_prime") && <TraceabilitySearch />}
      <RecallInspectionCard />
      <ConformitySummary ctx={ctx} />
      {!isLocked?.("pulizie") && <CleaningPlanCard ctx={ctx} />}
      <InspectionReport ctx={ctx} />
    </div>
  );
}
